(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["buy-buttons"] && !Shopify.designMode) return;
  try {
    document.addEventListener('variant:update', (event) => {
    const variantId = String(event.detail?.resource?.id ?? '');
    const productId = String(event.detail?.data?.productId ?? '');
    document.querySelectorAll('.coaster-box-personalization').forEach((container) => {
      if (container.dataset.productId !== productId) return;
      const input = container.querySelector('input[name="properties[Personalization text]"]');
      if (!input) return;
      const personalized = container.dataset.personalizedVariantIds.split(',').includes(variantId);
      container.hidden = !personalized;
      input.disabled = !personalized;
      input.required = personalized;
      if (!personalized) input.value = '';
    });
  });
  } catch(e) { console.error(e); }
})();

})();
